import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { moveToFolder, printMessages } from "src/actionCreators/receivedMessageActionCreators";
import { currentPageChanged, spamPageChanged } from "src/actionCreators/signalRActionCreators";
import {
    deleteMessage,
    fetchSpamMessages,
    getMessageDetail,
    markAsNotSpam,
    moveToInbox,
} from "src/actionCreators/spamMessageActionCreators";
import { initialPagination } from "src/Core/Common/Constants";
import { FolderType } from "src/Core/Common/Enums";
import { initialReceivedMessage, IReceivedMessageModel } from "src/Core/ViewModels/Message/ReceivedMessageModel";
import { appInsightsData } from "src/helper/AppInsightsData";
import { logger } from "src/routes/LoggedIn";
import { ApplicationState } from "src/store";
import MessageDetail from "./Common/MessageDetail";
import MessageList from "./Common/MessageList";
import { ResourceIdLocators } from "src/helper/ResourceIdLocators";

const Spam: React.FC = () => {
    const [isMessageDetailShow, toggleMessageDetailShow] = useState(false);
    const [pagination, setPagination] = useState(initialPagination);
    const [resetSelection, setSelection] = useState<boolean>(false);
    const dispatch = useDispatch();
    const messageState = useSelector((state: ApplicationState) => state.spamMessageState);
    const [reload, setReload] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState<IReceivedMessageModel>(initialReceivedMessage);

    useEffect(() => {
        logger.trackPageView(appInsightsData.MailBox.Spam.PageTitle);
        dispatch(currentPageChanged(FolderType.SPAM));
    }, []);

    const fetchMessages = (
        pageNo: number,
        pageSize: number,
        sortColumn?: string,
        sortOrder?: string,
        search?: string
    ) => {
        dispatch(fetchSpamMessages(FolderType.SPAM, pageNo, pageSize, sortColumn, sortOrder, search));
    };

    const pageNumberChanged = (pageNo: number) => {
        dispatch(spamPageChanged(pageNo));
    };

    const messageDetailCallback = (result: any) => {
        if (result.messageDetail) toggleMessageDetailShow(true);
        else toggleMessageDetailShow(false);
    };

    const handleOnDeleteMessage = (messages: IReceivedMessageModel[], callback: any) => {
        dispatch(deleteMessage(messages, callback, ResourceIdLocators.Spam.MsgListBtnDelete));
    };

    const handleGetMessageDetail = (message: IReceivedMessageModel) => {
        dispatch(getMessageDetail(message.receivedMessageId, message.messageType, messageDetailCallback));
    };

    const handleMessageDetailView = (result: boolean) => {
        if (result) toggleMessageDetailShow(false);
    };

    const handleMarkAsNotSpam = (messages: number[], callback?: any) => {
        dispatch(markAsNotSpam(messages, callback));
    };

    const handleMoveToInbox = (messageIds: number[], callback?: any) => {
        dispatch(moveToInbox(messageIds, callback));
    };

    const handleOnPrint = (): void => {
        dispatch(printMessages());
    };

    const checkFolderExpiry = (folderId: number): boolean => {
        //Need to confirm folder expiry logic implementation
        if (folderId) {
            return true;
        }
        return true;
    };

    const handleOnMoveToFolder = (messages: IReceivedMessageModel[], folderId: number, callback?: any): void => {
        dispatch(
            moveToFolder(
                messages,
                folderId,
                callback,
                appInsightsData.MailBox.Spam.PageTitle,
                ResourceIdLocators.Spam.MsgListBtnMoveToInbox
            )
        );
    };

    const handleResetSearchAndSort = () => {
        setReload(value => !value);
    };

    return (
        <div className="message-list-wrapper search-box-no-border-radius">
            <MessageList
                folderId={FolderType.SPAM}
                folderType={FolderType.SPAM}
                isLoading={messageState.isLoading}
                messages={messageState.data.messages}
                totalRecords={messageState.data.totalRecords}
                fetchMessages={fetchMessages}
                pageNumberChanged={pageNumberChanged}
                deleteMessages={handleOnDeleteMessage}
                getMessageDetail={handleGetMessageDetail}
                markAsNotSpam={handleMarkAsNotSpam}
                moveToInbox={handleMoveToInbox}
                print={handleOnPrint}
                checkFolderExpiry={checkFolderExpiry}
                moveToFolder={handleOnMoveToFolder}
                hideMessageDetailView={handleMessageDetailView}
                pagination={pagination}
                setPagination={setPagination}
                showMessageDetail={() => toggleMessageDetailShow(true)}
                resourceLocators={ResourceIdLocators.Spam}
                clearCheckBoxSelection={resetSelection}
                setSelection={setSelection}
                reload={reload}
                selectedMessage={selectedMessage}
                setSelectedMessage={setSelectedMessage}
            />
            {isMessageDetailShow && (
                <MessageDetail
                    message={messageState.mailData.data}
                    messageId={messageState?.mailData?.data?.messageDetail?.receivedMessageId}
                    folderType={FolderType.SPAM}
                    hideMessageDetailView={handleMessageDetailView}
                    pagination={pagination}
                    fetchMessages={fetchMessages}
                    hideMessageDetail={handleMessageDetailView}
                    resourceLocators={ResourceIdLocators.Spam}
                    resetSelection={setSelection}
                    resetSearchAndSort={handleResetSearchAndSort}
                />
            )}
        </div>
    );
};

export default Spam;
